import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActionResult, HelperFunctions } from 'bowman-commons';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BowmanCacheService } from 'bowman-cache';
import { BowmanLoggerService } from 'bowman-logger';

import { FlowType } from '../model/flow-type';
import { StepQueryResultContainer } from '../model/step-query-result-container';
import { SearchRequestDto } from 'src/app/shared/search-request-dto';

@Injectable({
    providedIn: 'root'
})

export class FlowTypeInspectService {
    private _mainUrl: string = window.location.pathname + '/api/flowInspect/';
    headers: HttpHeaders = new HttpHeaders();
    private _uuid: string;
    constructor(private _http: HttpClient,
    ) {

        this.headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json');
        this._uuid = HelperFunctions.uuid();
    }

    public search(flowTypeCode: FlowType['code'], request: SearchRequestDto): Observable<ActionResult<StepQueryResultContainer>> {
        const dataUrl = HelperFunctions.cleanUrl(this._mainUrl + 'search/' + flowTypeCode);
        return this._http.post<ActionResult<StepQueryResultContainer>>(dataUrl, request, { headers: this.headers }).pipe(catchError(this.handleError));
    }

    private handleError(error: any) {
        let parsedError: any;
        if (error && error.error && error.error.message) {
            parsedError = error.error.message;
        } else if (error && error.message) {
            parsedError = error.message;
        } else if (error && error._body) {
            parsedError = error._body;
        } else {
            parsedError = 'Flow Inspect Service Error';
        }
        return observableThrowError(parsedError);
    }

}
